import { render } from "./HideOnScroll.vue?vue&type=template&id=22349060"
import script from "./HideOnScroll.vue?vue&type=script&lang=js"
export * from "./HideOnScroll.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__